var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-input-container",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value"
          }
        ],
        ref: "input",
        staticClass: "search-input",
        class: { "in-header": _vm.inHeader },
        attrs: {
          type: "text",
          maxlength: "2048",
          placeholder: _vm.placeholderText,
          "data-testid": _vm.testId
        },
        domProps: { value: _vm.value },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.value = $event.target.value
            },
            _vm.update
          ],
          focus: function($event) {
            return _vm.$emit("focus")
          }
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "b-sprite-courses-magnifier" }),
      _vm._v(" "),
      _vm.value.length > 0
        ? _c("span", {
            staticClass: "b-sprite-courses-cross",
            attrs: { "data-testid": _vm.testId + "_clear" },
            on: { click: _vm.clear }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }